(function (ws) {
    'use strict';

    ws.views.shipFromHelp = ws.views.modal.extend({

        events: _.extend({}, ws.views.modal.prototype.events, {

        }),

        /**
         *
         * Initialize
         */
        initialize: function() {
            this.shipTocancel = $('.shipto-cancel');
            this.shipToSubmitdec = $('.shipto-submit');
            ws.views.modal.prototype.initialize.call(this);
            this.shipTocancel.on('click', this.cancelModal.bind(this));
            this.shipToSubmitdec.on('click', this.shipToSubmit.bind(this));
        },

        shipToSubmit: function(e) {
            console.log('submit');
            if ($('.shiptovat').val() === '') {
                $('.shipToVatErrorMsg').removeClass('hide');
                return;
            } else {
                $('.shipToVatErrorMsg').addClass('hide');
                $('.shipto-cancel').trigger('click');
                setTimeout(() => {
                    this.eventAgg.trigger('invoiceCountryHelpModalOpen');
                    let dynamicCntryTxt = $('.shiptovat option:selected').html();
                    $('.dynamicCountryText').html(dynamicCntryTxt);
                    $('.customerPayerVatReg').removeClass('hide');
                }, 500);
            }
        },

        cancelModal: function(e) {
            console.log('close');
            this.trigger('onClose');
            ws.views.modal.prototype.closeModal.call(this);

            //this.eventAgg.trigger('invoiceCountryHelpModalOpen');
        }
    });
})(westcon);
